import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Box, Typography, FormControl, Select, MenuItem, TextField, CircularProgress } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from '../../../redux/slices/OrderSlice';

const MyTable = () => {
  const dispatch = useDispatch();
  const { allorders, loading, error } = useSelector((state) => state.getorders);

  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);

  // Format data to match expected table structure
  const formattedData = allorders?.orders?.map((order, index) => ({
    id: order._id, 
    totalAmount: order.orderItems.orderTotal  || 0, 
    quantity: order.orderItems?.items?.length || 0
  })).reverse() || [];

  // Handle search filter
  const filteredData = formattedData.filter(item =>
    item.id.toString().includes(searchTerm) ||
    item.totalAmount.toString().includes(searchTerm) ||
    item.quantity.toString().includes(searchTerm)
  );

  // Handle pagination
  const startIndex = (page - 1) * entriesPerPage;
  const currentPageData = filteredData.slice(startIndex, startIndex + entriesPerPage);

  // Table columns
  const columns = [
    { name: 'Order ID', selector: row => row.id, sortable: true },
    { name: 'Total Amount', selector: row => row.totalAmount, sortable: true,
      cell: row => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>  
          <Typography sx={{ fontSize: '14px', fontWeight: '300' }}>₹
          {row.totalAmount}</Typography>
        </Box>
      ),
     },
    {
      name: 'Quantity',
      selector: row => row.quantity,
      sortable: true,
      cell: row => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ShoppingCartIcon sx={{ fontSize: '14px' }} />
          <Typography sx={{ fontSize: '14px', fontWeight: '300' }}>{row.quantity}</Typography>
        </Box>
      ),
    },
  ];

  return (
    <div>
      {/* Show loading state */}
      {loading && <CircularProgress sx={{ display: 'block', margin: '20px auto' }} />}
      {error && <Typography color="error">{error}</Typography>}

      {!loading && !error && (
        <>
          {/* Entries per Page and Search Bar Section */}
          <Box sx={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ mr: 1 }}>Show</Typography>
              <FormControl sx={{ p: 1 }}>
                <Select
                  value={entriesPerPage}
                  onChange={(e) => { setEntriesPerPage(e.target.value); setPage(1); }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="body1" sx={{ mr: 1 }}>entries</Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ mr: 1 }}>Search:</Typography>
              <TextField
                variant="outlined"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
              />
            </Box>
          </Box>
          <DataTable
            columns={columns}
            data={currentPageData}
            pagination
            paginationServer
            paginationTotalRows={filteredData.length}
            onChangePage={(newPage) => setPage(newPage)}
            paginationPerPage={entriesPerPage}
            paginationComponentOptions={{ noRowsPerPage: true }}
            customStyles={{
              headCells: { style: { fontSize: '16px', fontWeight: 'bold', color: '#333' } },
              cells: { style: { fontSize: '14px', color: '#3c7f06', fontWeight: '300' } },
            }}
          />
        </>
      )}
    </div>
  );
};

export default MyTable;
